import React, { Component } from 'react';
import { AppContext } from '../context';
import { LanguageType } from '../types/language.type';
import TranslationService from '../services/translation.service';

class Text extends Component<{text?: string, language?: LanguageType}> {
  static contextType = AppContext;
  context!: React.ContextType<typeof AppContext>;

  getMessage (text: string) {
    const { state } = this.context;
    const { language } = state;
    return TranslationService.getMessage(text, language);
  }

  componentDidMount() {
    if (this.props.language) {
      const { dispatch } = this.context;
      dispatch({
        type: 'setLanguage',
        payload: {
          language: this.props.language
        }
      });
    }
  }

  render ()  {
    return <>
      {this.props.text && this.getMessage(this.props.text)}
    </>
  };
}
export default Text;
